import { render, staticRenderFns } from "./GoalsPanel.vue?vue&type=template&id=f23d45ac&lang=pug&"
import script from "./GoalsPanel.vue?vue&type=script&lang=js&"
export * from "./GoalsPanel.vue?vue&type=script&lang=js&"
import style0 from "./GoalsPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports